<template>
  <div class="container">
    <div class="left-wrapper">
      <div
        v-for="(item) in leftColumn"
        :key="item.id"
        :class="activeId === item.id ? 'column-item active-item' : 'column-item'"
        @mouseover="activeItem(item.id)"
        @click="toDetail(item.id)"
      >
        <div class="item-box">
          <img :src="item.icon" alt="" class="column-item__img round_icon">
          {{ item.column }}
        </div>

        <span v-if="activeId === item.id" class="iconfont arrow-left">&#xe67d;</span>
      </div>
    </div>
    <div class="swapper-wrapper">
      <el-carousel
        height="376px"
        :interval="5000"
        trigger="click"
        v-for="item in bannerList"
        :key="item.id"
        v-show="item.id === activeId"
        arrow="never"
      >
        <el-carousel-item
          v-for="(banner,index) in item.banners"
          :key="index"
        >
          <img class="banner-img" :src="banner" alt="banner"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="right-wrapper">
      <div
        v-for="(item) in rightColumn"
        :key="item.id"
        :class="activeId === item.id ? 'column-item active-item' : 'column-item'"
        @mouseover="activeItem(item.id)"
        @click="toDetail(item.id)"
      >
        <div class="item-box">
          <img :src="item.icon" alt="" class="column-item__img round_icon">
          {{ item.column }}
        </div>

        <span v-if="activeId === item.id" class="iconfont arrow-right">&#xe67e;</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import axios from 'axios'
import { requestUrl, orgId } from '../common/constant'

export default {
  name: 'LosAngeles',
  props: {
    laProps: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      leftColumn: [],
      rightColumn: [],
      bannerList: [],
      activeId: ''
    }
  },
  watch: {
    laProps: function (data) {
      if (!data) {
        return
      }

      const leftColumn = []
      const rightColumn = []
      const bannerList = []

      for (let i = 0; i < data.length; i++) {
        const flag = data[i]
        if (i < 4) {
          leftColumn.push({
            id: flag.id,
            column: flag.name,
            icon: flag.icon
          })
        } else {
          rightColumn.push({
            id: flag.id,
            column: flag.name,
            icon: flag.icon
          })
        }

        bannerList.push({
          id: flag.id,
          banners: flag.image.split(',')
        })

        this.leftColumn = leftColumn
        this.rightColumn = rightColumn
        this.bannerList = bannerList
        this.activeId = leftColumn[0].id
      }
    }
  },
  methods: {
    ...mapMutations([
      'updateMainColumnId'
    ]),
    activeItem (id) {
      this.activeId = id
    },
    async toDetail (id) {
      const result = await axios.get(`${requestUrl}/news/article?id=${id}&orgId=${orgId}`)
      const articleId = result.data[0].id
      this.$router.push({
        path: `/content/${articleId}`
      })
    }
  }
}
</script>

<style scoped>
.round_icon {
  width: 34px;
  height: 34px;
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.swapper-wrapper >>> .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #fff;
  opacity: .48;
}

.swapper-wrapper >>> .is-active .el-carousel__button {
  opacity: 1;
}

.swapper-wrapper >>> .el-carousel__arrow {
  font-size: 24px;
}

.container {
  width: 1180px;
  height: 376px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 1px solid #cccccc;
  box-shadow: 1px 1px 4px #ccc;
}

.left-wrapper {
  height: 100%;
  width: 15%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.swapper-wrapper {
  height: 100%;
  width: 70%;
  box-sizing: border-box;
}

.banner-img {
  height: 376px;
  width: 100%;
  border: none;
}

.item-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.column-item {
  position: relative;
  height: 131px;
  width: 100%;
  background-color: #fff;
  font-font: "微软雅黑";
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #cccccc;
}

.column-item__img {
  height: 40px;
  width: 40px;
  margin-bottom: 10px;
}

.arrow-left {
  font-size: 30px;
  color: rgb(1, 142, 214);
  position: absolute;
  top: 50%;
  left: 168px;
  transform: translateY(-50%);
  z-index: 999;
}

.arrow-right {
  font-size: 30px;
  color: rgb(1, 142, 214);
  position: absolute;
  top: 50%;
  right: 168px;
  transform: translateY(-50%);
  z-index: 999;
}

.active-item {
  background-color: rgb(1, 142, 214);
  color: #ffffff;
  cursor: pointer;
}

.right-wrapper {
  height: 100%;
  width: 15%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}
</style>
